import { useFormik } from "formik";
import axios from "axios";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import Layout from "../assets/component/Layout";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_API_URL;

export default function FeePaymentForm() {
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            studentName: "",
            rollNumber: "",
            courseSemester: "",
            feeBreakdown: "",
            paymentMode: "",
            transactionId: "",
            dateOfPayment: "",
        },
        onSubmit: async (values) => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.post(`${BASE_URL}create-fee`, values, {
                    headers: { Authorization: token },
                });

                if (response.status === 200) {
                    navigate("/engineers-forms");
                }
            } catch (error) {
                console.error("Submission error:", error);
            }
        },
    });

    return (
        <Layout>
            <section className="Inner-page-layout">
                <div>
                    <h1>Fee Payment Form</h1>
                    <div className="application-forms-cards">
                        <Container>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Student Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="studentName"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.studentName}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Roll Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rollNumber"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.rollNumber}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Course/Semester</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="courseSemester"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.courseSemester}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fee Breakdown (Tuition, Hostel, Exam, etc.)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="feeBreakdown"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.feeBreakdown}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mode of Payment (Cash/Online/DD)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="paymentMode"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.paymentMode}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Transaction ID</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="transactionId"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.transactionId}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date of Payment</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="dateOfPayment"
                                                onChange={formik.handleChange}
                                                value={formik.values.dateOfPayment}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="text-center mt-3">
                                    <Button type="submit">Save</Button>
                                </div>
                            </Form>
                        </Container>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
